import { useEffect } from 'react';
import {
	acquireSessionReplayWindow,
	releaseSessionReplayWindow,
} from './sessionRecording';

/**
 * Declara que ESTA superficie quiere grabarse mientras `active` sea true.
 *
 * Es la única API que tocan las pantallas: agregar una superficie a la
 * grabación es una línea, no un cambio en el motor. Las ventanas se cuentan por
 * referencia (ver `openWindows` en sessionRecording), así que dos superficies
 * anidadas conviven sin que el desmontaje de la interior corte a la exterior.
 *
 * `active` existe para las superficies que solo valen la pena grabar cuando el
 * usuario hace algo — el formulario de vinculación se graba cuando ya empezó a
 * escribir su RFC, no por el hecho de estar en pantalla. Baja el costo de cuota
 * y deja fuera al que solo pasó de largo.
 *
 * OJO con el límite físico: rrweb NO graba hacia atrás. Lo que ocurrió antes de
 * que `active` se volviera true no queda en el video. Si lo que se investiga es
 * la duda ANTES de actuar (por qué tardó en escribir), la ventana tiene que
 * abrir al montar, no al interactuar.
 *
 * useEffect legítimo: integra con un sistema externo a React (el grabador).
 */
export const useSessionReplayWindow = (
	reason: string,
	active: boolean = true,
): void => {
	useEffect(() => {
		if (!active) return;
		acquireSessionReplayWindow(reason);
		return () => releaseSessionReplayWindow(reason);
	}, [reason, active]);
};
